import { useCallback, useMemo } from 'react';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

import { useIsDesktop } from './useIsDesktop';
import usePinsAccount from './usePinsAccount';
import { useTeamStore } from './useTeamStore';
import useToast from './useToast';

import { DetailsPlayerSubmit } from '@/components/Team/DetailsPlayer';
import { requestTransfer } from '@/services/commonsTeam';
import { TeamActionTypes } from '@/store';
import { RequestTransfer } from '@/types/team';
import { resetStatePostTransfer, TEXTS } from '@/utils';

export const useHandleTransfer = (isF5 = false) => {
  const { state, dispatch } = useTeamStore();
  const toast = useToast();
  const { pinsData, handleSetPinsData } = usePinsAccount();
  const { isDesktop } = useIsDesktop();

  const {
    mutateAsync: makeTransfer,
    data: responseTransfer,
    isLoading: isLoadingTransfer,
  } = useMutation(async (transfer: RequestTransfer) => {
    return await requestTransfer(transfer, isF5);
  });

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const team = useMemo(() => {
    return isF5 ? state.teamF5 : state.team;
  }, [isF5, state.team, state.teamF5]);

  const handleTransferSubmit = useCallback(
    async (data: DetailsPlayerSubmit, pin?: string) => {
      if (state.selectedPlayerOnList?.id && state.selectedPlayerOnTeam?.id) {
        dispatch({
          type: TeamActionTypes.SET_STATE,
          payload: {
            ...(isDesktop && { selectedPlayerOnList: data.player }),
            addToTeamBySuggestionModal: false,
            playerDetailsModalOpen: false,
            // pedido en la https://agea.atlassian.net/browse/DTA-5759
            // ...(!isF5 && { playerDetailsModalOpen: false }),
          },
        });
        if (team) {
          const existOnTeam = team.some(
            (player) => player.id === state.selectedPlayerOnList?.id
          );

          if (existOnTeam) {
            toast.show(TEXTS.team.playerAlreadyExists);
            return;
          }
        }
        // se realiza transferencia
        const response = await makeTransfer({
          jugador_entra: state.selectedPlayerOnList?.id,
          jugador_sale: state.selectedPlayerOnTeam?.id,
          idTipoTransferencia: 0,
          ...(!isF5 ? { pin: pin || '' } : { pin }),
        });

        if (response?.estado) {
          // limpio hash modal y estado
          dispatch(resetStatePostTransfer);
          navigate(pathname);
          if (pin) {
            handleSetPinsData({
              ...pinsData,
              showInputsModalPins: false,
            });
          } else {
            !pinsData.isPremium &&
              handleSetPinsData({
                ...pinsData,
                ...(!isF5 &&
                  response.pinesDisponibles !== undefined && {
                    pinsAvailable: response.pinesDisponibles,
                  }),
                showInputsModalPins: false,
              });
          }
        }
      }
    },
    [
      dispatch,
      handleSetPinsData,
      isDesktop,
      isF5,
      makeTransfer,
      navigate,
      pathname,
      pinsData,
      state.selectedPlayerOnList?.id,
      state.selectedPlayerOnTeam?.id,
      team,
      toast,
    ]
  );

  return {
    responseTransfer,
    isLoadingTransfer,
    handleTransferSubmit,
  };
};
